document.addEventListener('DOMContentLoaded', function() {
  const budgetSelect = document.querySelector('.budget-loc');
  const locationInfos = document.querySelectorAll('.location-info');
  const openModalBtn = document.getElementById('openModalBtn');
  const closeModalBtn = document.getElementById('closeModalBtn');
  const modal = document.getElementById('modal');
  const modalForm = document.getElementById('modalForm');
  
  let dataTypeValue;

  // Get companyId from data attribute on the section
  const budgetSection = document.querySelector('[data-budget-company-id]');
  const companyId = budgetSection ? budgetSection.dataset.budgetCompanyId : null;

  // When the select value changes
  budgetSelect.addEventListener('change', function() {
    const selectedIndex = this.value;

    // Hide all location-info divs
    locationInfos.forEach(function(el) {
      el.style.display = 'none';
    });

    // Show the div that has the corresponding index
    const targetInfo = document.querySelector('.location-info[data-index="' + selectedIndex + '"]');
    if (targetInfo) {
      targetInfo.style.display = 'block';
    }

    // Update dataTypeValue
    updateDataType();
  });

  // Trigger change event on page load to show the first item
  budgetSelect.dispatchEvent(new Event('change'));

  // Open Modal
  if (openModalBtn) {
    openModalBtn.addEventListener('click', function() {
      modal.style.display = 'flex';
    });
  }

  // Close Modal on clicking close button
  if (closeModalBtn) {
    closeModalBtn.addEventListener('click', function() {
      fadeOut(modal);
    });
  }

  // Close Modal on clicking outside
  window.addEventListener('click', function(e) {
    if (e.target === modal) {
      fadeOut(modal);
    }
  });

  // Simple fadeOut function
  function fadeOut(element) {
    element.style.opacity = '1';
    element.style.transition = 'opacity 0.3s';
    element.style.opacity = '0';
    setTimeout(function() {
      element.style.display = 'none';
      element.style.opacity = '1';
    }, 300);
  }

  // Function to check dropdown values of company location
  function updateDataType() {
    const selectedOption = budgetSelect.options[budgetSelect.selectedIndex];
    dataTypeValue = selectedOption ? parseInt(selectedOption.dataset.type, 10) : null;
    console.log(dataTypeValue);
    checkRoleAssignment(dataTypeValue);
  }

  // Form submission event
  if (modalForm) {
    modalForm.addEventListener('submit', function(event) {
      event.preventDefault();
      
      const numberValue = document.getElementById('numberField').value;
      console.log(dataTypeValue);

      // Define the GraphQL endpoint
      const graphqlEndpoint = '/admin/api/2023-01/graphql.json';

      // Define the GraphQL mutation
      const query = `
        mutation MetafieldsSet($metafields: [MetafieldsSetInput!]!) {
          metafieldsSet(metafields: $metafields) {
            metafields {
              key
              namespace
              value
              createdAt
              updatedAt
            }
            userErrors {
              field
              message
              code
            }
          }
        }
      `;

      // Define the variables for the mutation
      const variables = {
        metafields: [
          {
            key: "total_budget",
            namespace: "custom",
            ownerId: "gid://shopify/CompanyLocation/" + dataTypeValue,
            type: "single_line_text_field",
            value: numberValue
          }
        ]
      };

      // Make the fetch request
      fetch(graphqlEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Access-Token': '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'
        },
        body: JSON.stringify({ query, variables })
      })
      .then(response => response.json())
      .then(data => {
        if (data.errors) {
          console.error('GraphQL errors:', data.errors);
        } else {
          console.log('Metafield updated:', data.data.metafieldsSet.metafields);
          alert("Data has been Updated. The changes will be implemented from the coming month");
          location.reload();
        }
      })
      .catch(error => console.error('AJAX error:', error));

      fadeOut(modal);
    });
  }

  // Fetch company contact role assignments
  async function getCompanyContactRoleAssignments() {
    if (!companyId) {
      console.error("Company ID not found");
      return null;
    }

    const query = `
      query($companyId: ID!) {
        company(id: $companyId) {
          id
          name
          contacts(first: 1) {
            nodes {
              roleAssignments(first: 100) {
                nodes {
                  role {
                    name
                  }
                  companyContact {
                    id
                  }
                  companyLocation {
                    id,
                    name
                  }
                }
              }
            }
          }
        }
      }
    `;

    const variables = {
      companyId: `gid://shopify/Company/${companyId}`
    };

    const url = `https://misradia.myshopify.com/admin/api/2023-01/graphql.json`;

    const options = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Access-Token': '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',
      },
      body: JSON.stringify({ query, variables }),
    };

    try {
      const response = await fetch(url, options);
      const data = await response.json();

      if (data.errors) {
        console.error("GraphQL errors:", data.errors);
        return null;
      }

      const roleAssignments = data.data.company?.contacts?.nodes[0]?.roleAssignments?.nodes;

      if (!roleAssignments || roleAssignments.length === 0) {
        console.log("No role assignments found.");
        return null;
      }

      const roleNames = roleAssignments.map(assignment => assignment.role.name);
      const companyContactIds = roleAssignments.map(assignment => assignment.companyContact.id);
      const companyLocationNames = roleAssignments.map(assignment => assignment.companyLocation.id);

      const integerLocationIds = companyLocationNames.map(location => {
        const parts = location.split("/");
        const lastPart = parts[parts.length - 1];
        const integerId = parseInt(lastPart, 10);
        return isNaN(integerId) ? null : integerId;
      }).filter(id => id !== null);

      return { roleNames, companyContactIds, companyLocationNames, integerLocationIds };

    } catch (error) {
      console.error("Error fetching company contact role assignments:", error);
      return null;
    }
  }

  // Call the function to fetch the data
  getCompanyContactRoleAssignments();

  async function checkRoleAssignment(dataTypeValue) {
    const result = await getCompanyContactRoleAssignments();
    
    if (!result) {
      console.log("Data not fetched correctly.");
      return;
    }

    const { roleNames, companyContactIds, companyLocationNames, integerLocationIds } = result;

    const matchingIndex = integerLocationIds.findIndex(id => id === dataTypeValue);

    if (matchingIndex !== -1) {
      const roleAtIndex = roleNames[matchingIndex];

      const button = document.querySelector('.btn-restrict-location-role');
      if (button) {
        if (roleAtIndex === "Ordering only") {
          button.style.display = 'none';
        } else {
          button.style.display = 'block';
        }
      }
    } else {
      console.log("No matching location ID found for dataTypeValue:", dataTypeValue);
    }
  }

  // Function to fetch company locations metafields
  async function getCompanyLocations() {
    const query = `
      query {
        companyLocations(first: 50) {
          edges {
            node {
              id
              name
              metafields(first: 10) {
                nodes {
                  key
                  value
                }
              }
            }
          }
        }
      }
    `;

    const url = `https://misradia.myshopify.com/admin/api/2023-01/graphql.json`;
    const options = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Access-Token': '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',
      },
      body: JSON.stringify({ query }),
    };

    try {
      const response = await fetch(url, options);
      const data = await response.json();

      if (data.errors) {
        console.error("GraphQL errors:", data.errors);
        return null;
      }

      const companyLocations = data.data.companyLocations.edges.map(edge => {
        const location = {
          id: edge.node.id,
          name: edge.node.name,
          budget_type: null,
          total_budget: null,
          available_budget: null,
          last_reset: null,
        };

        edge.node.metafields.nodes.forEach(metafield => {
          if (metafield.key === "budget_type") {
            location.budget_type = metafield.value;
          } else if (metafield.key === "total_budget") {
            location.total_budget = metafield.value;
          } else if (metafield.key === "available_budget") {
            location.available_budget = metafield.value;
          } else if (metafield.key === "last_reset") {
            location.last_reset = metafield.value;
          }
        });

        return location;
      });

      console.log(companyLocations);

      const matchedLocations = data.data.companyLocations.edges.map(edge => {
        const location = {
          id: edge.node.id,
          name: edge.node.name,
          budget_type: null,
          total_budget: null,
          available_budget: null,
        };

        edge.node.metafields.nodes.forEach(metafield => {
          if (metafield.key === "budget_type") {
            location.budget_type = metafield.value.replace(/[\/\[\]\s"]/g, '');
          } else if (metafield.key === "total_budget") {
            location.total_budget = metafield.value;
          } else if (metafield.key === "available_budget") {
            location.available_budget = metafield.value;
          }
        });

        return location;
      }).filter(location => location.budget_type == "1");

    } catch (error) {
      console.error("Error fetching company locations:", error);
      return null;
    }
  }

  getCompanyLocations();

  // Function to perform the mutation and update the location's metafields
  async function updateLocationMetafields(locationId, availableBudget) {
    const mutation = `
      mutation UpdateCompanyLocationMetafields($id: ID!, $availableBudget: String!) {
        companyLocationUpdate(input: { 
          id: $id, 
          metafields: [
            { key: "available_budget", value: $availableBudget, namespace: "global", type: STRING }
          ]
        }) {
          companyLocation {
            id
            name
            metafields(first: 10) {
              nodes {
                key
                value
              }
            }
          }
        }
      }
    `;

    const variables = {
      id: locationId,
      availableBudget: availableBudget.toString()
    };

    const url = `https://misradia.myshopify.com/admin/api/2023-01/graphql.json`;

    const options = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Access-Token': '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',
      },
      body: JSON.stringify({ query: mutation, variables }),
    };

    try {
      const response = await fetch(url, options);
      const data = await response.json();

      if (data.errors) {
        // console.error("GraphQL errors while updating:", data.errors);
      } else {
        // console.log(`Location ${locationId} updated successfully`);
      }

    } catch (error) {
      // console.error("Error updating location:", error);
    }
  }
});

